import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircle, Search, Percent, ArrowLeft, RefreshCw } from 'lucide-react';
import { getTasas, deleteTasa } from '../services/tasaService';
import toast, { Toaster } from 'react-hot-toast';

const TasaList = () => {
    const [tasas, setTasas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchTasas();
    }, []);

    const fetchTasas = async () => {
        try {
            setLoading(true);
            console.log('Iniciando fetch de tasas con token:', token ? 'Presente' : 'AUSENTE');
            const data = await getTasas(token);
            console.log('Datos de tasas recibidos:', data);
            setTasas(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error detallado en fetchTasas:', error);
            toast.error('Error al cargar las tasas de interés');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar esta tasa?')) return;
        try {
            await deleteTasa(token, id);
            toast.success('Tasa eliminada correctamente');
            fetchTasas();
        } catch (error) {
            toast.error('Error al eliminar la tasa');
        }
    };

    const filteredTasas = tasas.filter(t => {
        const productSearch = (t.tipoCredito?.descripcion || t.tipoCuenta?.descripcion || '').toLowerCase();
        return productSearch.includes(searchTerm.toLowerCase());
    });

    return (
        <div className="max-w-[98%] mx-auto bg-white shadow-sm border border-gray-200 mb-10 overflow-hidden rounded-sm animate-in fade-in duration-500">
            <Toaster position="top-right" />

            {/* Header Enterprise Style */}
            <div className="bg-slate-700 p-3 flex justify-between items-center text-white">
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(-1)}
                        className="p-1.5 hover:bg-slate-600 rounded-full transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <div className="h-8 w-[2px] bg-slate-500 mx-1"></div>
                    <div>
                        <h1 className="text-lg font-semibold uppercase tracking-tight flex items-center gap-2">
                            <Percent className="w-5 h-5 text-blue-400" />
                            Mantenimiento: Tasas de Interés
                        </h1>
                    </div>
                </div>
                <button
                    onClick={() => navigate('/parametrizacion/tasas/nueva')}
                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-sm text-xs font-black transition-all shadow-lg active:scale-95 uppercase"
                >
                    <PlusCircle className="w-4 h-4" />
                    Nueva Tasa
                </button>
            </div>

            {/* Controles y Búsqueda */}
            <div className="p-4 bg-gray-50 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="flex items-center gap-3 text-xs font-bold text-gray-500 uppercase">
                    <span>Mostrar</span>
                    <select className="border border-gray-300 rounded px-2 py-1 bg-white outline-none focus:ring-1 focus:ring-blue-500">
                        <option>10</option>
                        <option>20</option>
                        <option>50</option>
                    </select>
                    <span>registros</span>
                </div>

                <div className="relative w-full md:w-96">
                    <input
                        type="text"
                        placeholder="BUSCAR POR TIPO DE PRODUCTO..."
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-sm text-xs font-bold uppercase tracking-wider outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all shadow-sm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Search className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" />
                </div>
            </div>

            {/* Tabla Enterprise con Scroll Horizontal */}
            <div className="overflow-x-auto relative">
                <table className="min-w-full text-left border-collapse table-fixed bg-white">
                    <thead>
                        <tr className="bg-[#f8fafc] border-b-2 border-slate-200 text-gray-700 text-[11px] font-bold uppercase tracking-wider">
                            <th className="px-3 py-3 w-16 text-center border-r border-gray-100 sticky left-0 bg-[#f8fafc] z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">ID</th>
                            <th className="px-4 py-3 w-64 border-r border-gray-100">Producto (Crédito/Cuenta)</th>
                            <th className="px-4 py-3 w-28 border-r border-gray-100 text-center">TAN (%)</th>
                            <th className="px-4 py-3 w-28 border-r border-gray-100 text-center">TAE (%)</th>
                            <th className="px-4 py-3 w-40 border-r border-gray-100 text-center">Inicio Vigencia</th>
                            <th className="px-4 py-3 w-40 border-r border-gray-100 text-center">Fin Vigencia</th>
                            <th className="px-4 py-3 w-32 border-r border-gray-100 text-center">Estado</th>
                            <th className="px-3 py-3 w-32 text-center sticky right-0 bg-[#f8fafc] shadow-[-4px_0_10px_-4px_rgba(0,0,0,0.1)] border-l border-gray-100 z-10 font-black">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="text-[11px] text-gray-700 font-semibold uppercase">
                        {loading && tasas.length === 0 ? (
                            <tr>
                                <td colSpan="8" className="px-4 py-20 text-center text-gray-400 font-bold uppercase italic">
                                    <div className="flex flex-col items-center gap-3">
                                        <RefreshCw className="w-8 h-8 animate-spin text-blue-500 opacity-20" />
                                        Sincronizando con la Entidad...
                                    </div>
                                </td>
                            </tr>
                        ) : filteredTasas.length === 0 ? (
                            <tr><td colSpan="8" className="px-4 py-10 text-center text-gray-400 font-bold uppercase italic border-b border-gray-200">No se encontraron registros de tasas.</td></tr>
                        ) : (
                            filteredTasas.map((t) => (
                                <tr key={t.id} className="border-b border-gray-100 hover:bg-[#f1f5f9] transition-colors group">
                                    <td className="px-3 py-3 text-center font-mono text-[11px] text-gray-400 border-r border-gray-100 sticky left-0 bg-white group-hover:bg-[#f1f5f9] z-10 shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)]">
                                        {t.id}
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 font-bold text-slate-800">
                                        {t.tipoCredito?.descripcion || t.tipoCuenta?.descripcion || 'NO DEFINIDO'}
                                        <div className="text-[9px] text-gray-400 font-normal italic">
                                            {t.tipoCredito ? 'CARTERA DE CRÉDITO' : 'PRODUCTO DE AHORRO'}
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 text-center font-black text-gray-900 bg-gray-50/30">
                                        {t.tan}%
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 text-center font-black text-blue-700 bg-blue-50/10">
                                        {t.tae}%
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 text-center text-slate-500">
                                        {t.fechaInicioVigencia}
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 text-center text-slate-400 italic">
                                        {t.fechaFinVigencia || 'VIGENTE INDEFINIDO'}
                                    </td>
                                    <td className="px-4 py-3 border-r border-gray-100 text-center">
                                        <span className={`px-2 py-0.5 rounded-full text-[9px] font-black border ${t.esActiva
                                            ? 'bg-green-100 text-green-700 border-green-200 shadow-sm shadow-green-100'
                                            : 'bg-gray-100 text-gray-500 border-gray-200'
                                            }`}>
                                            {t.esActiva ? 'ACTIVO' : 'INACTIVO'}
                                        </span>
                                    </td>
                                    <td className="px-3 py-3 text-center sticky right-0 bg-white shadow-[-4px_0_10px_-4px_rgba(0,0,0,0.1)] border-l border-gray-100 group-hover:bg-[#f1f5f9] z-10">
                                        <div className="flex justify-center items-center gap-2 font-bold text-[10px] tracking-tight">
                                            <button
                                                onClick={() => navigate(`/parametrizacion/tasas/${t.id}/editar`)}
                                                className="text-blue-600 hover:text-blue-800 transition-colors uppercase"
                                            >
                                                EDITAR
                                            </button>
                                            <span className="text-gray-300">|</span>
                                            <button
                                                onClick={() => handleDelete(t.id)}
                                                className="text-red-500 hover:text-red-700 transition-colors uppercase"
                                            >
                                                ELIMINAR
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginación Footer */}
            <div className="p-3 bg-gray-50 border-t border-gray-200 flex justify-between items-center text-[10px] text-gray-500 uppercase font-black">
                <div>
                    Mostrando <span className="text-gray-700">{filteredTasas.length}</span> definiciones de tasas
                </div>
                <div className="flex items-center gap-1">
                    <button disabled className="px-2 py-1 border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-30 rounded-sm italic">Anterior</button>
                    <div className="px-3 py-1 border border-blue-600 bg-blue-600 text-white font-bold rounded-sm">1</div>
                    <button disabled className="px-2 py-1 border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-30 rounded-sm italic">Siguiente</button>
                </div>
            </div>
        </div>
    );
};

export default TasaList;
